import { render, staticRenderFns } from "./GenderCategoryFormal.vue?vue&type=template&id=0faa55ac&"
import script from "./GenderCategoryFormal.vue?vue&type=script&lang=js&"
export * from "./GenderCategoryFormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports